import { SVGAttributes } from 'react'

const PlayIcon = (props: SVGAttributes<SVGElement>) => (
    <svg fill={props.color || 'white'} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.75 0C22.9926 0 24 1.00736 24 2.25V21.75C24 22.9926 22.9926 24 21.75 24H2.25C1.00736 24 0 22.9926 0 21.75V2.25C0 1.00736 1.00736 0 2.25 0H21.75ZM8.44596 5.78246C8.36945 5.78246 8.29533 5.80384 8.2236 5.8466L8.21053 18.513C8.26791 18.5593 8.34084 18.5825 8.4293 18.5825C8.43362 18.5825 8.45441 18.5716 8.49167 18.55L8.53442 18.5248C9.12943 18.1691 12.2302 16.1685 17.8367 12.523C17.8941 12.4767 17.9228 12.4215 17.9228 12.3573C17.9228 12.2932 17.8941 12.2379 17.8367 12.1916L8.66115 5.8466C8.58942 5.80384 8.51769 5.78246 8.44596 5.78246Z"
        />
    </svg>
)

export default PlayIcon
